"use client";
import { Stack, Text, Icon, Box } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { MdOutlineDoneAll } from "@onemind-services-llc/react-icons-ng/md";
import Img1 from "public/iaas/costEfficient.4c199bb4.svg";
import Img2 from "public/iaas/wordpress-service.2952b864.svg";

type DescriptionProps = {
  points: { label: string; text: string }[];
};

const Content = (props: DescriptionProps) => {
  const { points } = props;
  const textVariant = useTextVariants();
  return (
    <Stack>
      {points.map((point, i) => (
        <Box color={"text.100"} key={i}>
          <Text variant={textVariant} as="span" fontWeight={600}>
            <Box as="span" display="inline-flex" alignItems="center" mt={2} mr={2}>
              <Icon as={MdOutlineDoneAll} />
            </Box>
            {point.label} -{" "}
          </Text>
          <Text variant={textVariant} as="span">
            {point.text}
          </Text>
        </Box>
      ))}
    </Stack>
  );
};

export const SOLUTIONS_CONSTANTS = {
  title: "Onemind’s Disaster Recovery Solutions – How We Help You",
  desc: "At Onemind, we provide a turnkey Disaster Recovery as a Service (DRaaS) solution that ensures seamless business continuity, rapid failover, and secure cloud-based disaster recovery.",
  list: [
    {
      image: Img1,
      title: "Onemind’s DRaaS – Instant & Secure Recovery for Any Disaster",
      content: (
        <Content
          points={[
            {
              text: "Manage disaster recovery seamlessly via a single dashboard, eliminating multi-platform complexity.",
              label: "Fully Managed DR Solution",
            },
            {
              text: "Automatically restore critical applications within minutes, reducing downtime and financial loss.",
              label: "Instant Failover & Recovery",
            },
            {
              text: "Protect sensitive data with encryption, access controls, and continuous monitoring.",
              label: "Multi-Layer Security",
            },
            {
              text: "Integrates with on-premises, hybrid, and cloud environments for flexible recovery options.",
              label: "Hybrid & Multi-Cloud Compatibility",
            },
          ]}
        />
      ),
    },
    {
      image: Img2,
      title: "Onemind’s Disaster Recovery Deployment Options",
      content: (
        <Content
          points={[
            {
              text: "Fully automated cloud failover, minimizing recovery time and infrastructure costs.",
              label: "Cloud-Based DR",
            },
            {
              text: "Local backup and recovery for organizations requiring on-site data protection.",
              label: "On-Premises DR",
            },
            {
              text: "Combine cloud and on-premises strategies for customized redundancy and security.",
              label: "Hybrid DR",
            },
            {
              text: "Store backups across multiple data centers for maximum resilience.",
              label: "Geographically Redundant DR",
            },
          ]}
        />
      ),
    },
  ],
};
